/**
 * Created by dina.shomer on 17-03-13.
 */

function CategoryIcon() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;

    this.init = function() {
        var counter=0; //set counter we only want one
        var tagsArray=(this.tags).split(",");
        //console.log (this.tags);
        //console.log(tagsArray.length);
        for(var i=0, l=tagsArray.length; i<l; i++) {
            if(tagsArray[i].toLowerCase() =='featured'){
                counter=2;
            }else{
                if (counter<1){
                   counter=1;
                   theTag = tagsArray[i].toLowerCase();
                }

            }
            if (counter==2){
                theTag='featured';
            }
        };
        //console.log(theTag);

       $(this.node).addClass("iconTab");
       $(this.node).addClass(theTag+'-icon');
       $(this.node).css("display", "block");
    };
    this.initAllReady = function() {
    };

}
